import dashboardV2Service from '../services/dashboardV2Service';
import {
  FETCH_LAYOUT_V2,
  SAVE_LAYOUT_V2,
  ADD_WIDGET_V2,
  UPDATE_WIDGET_POSITIONS_V2,
  UPDATE_WIDGET_CONFIG_V2,
  DELETE_WIDGET_V2,
  FETCH_WIDGET_DATA_V2,
  FETCH_BATCH_WIDGET_DATA_V2,
  SET_DASHBOARD_V2_LOADING,
  SET_DASHBOARD_V2_ERROR
} from './types';

// ==================== Layout Actions ====================

export const fetchLayoutV2 = () => ({
  type: FETCH_LAYOUT_V2,
  promise: dashboardV2Service.getLayout()
});

export const saveLayoutV2 = (layoutData) => ({
  type: SAVE_LAYOUT_V2,
  promise: dashboardV2Service.saveLayout(layoutData)
});

// ==================== Widget Management Actions ====================

export const addWidgetV2 = (widgetData) => ({
  type: ADD_WIDGET_V2,
  promise: dashboardV2Service.addWidget(widgetData)
});

export const updateWidgetPositionsV2 = (widgets) => ({
  type: UPDATE_WIDGET_POSITIONS_V2,
  promise: dashboardV2Service.updateWidgetPositions(widgets),
  meta: { widgets }
});

export const updateWidgetConfigV2 = (widgetId, config) => ({
  type: UPDATE_WIDGET_CONFIG_V2,
  promise: dashboardV2Service.updateWidget(widgetId, config),
  meta: { widgetId }
});

export const deleteWidgetV2 = (widgetId) => ({
  type: DELETE_WIDGET_V2,
  promise: dashboardV2Service.deleteWidget(widgetId),
  meta: { widgetId }
});

// ==================== Widget Data Actions ====================

export const fetchWidgetDataV2 = (widgetId, tipo, params) => ({
  type: FETCH_WIDGET_DATA_V2,
  promise: dashboardV2Service.getWidgetData(widgetId, tipo, params),
  meta: { widgetId, tipo }
});

export const fetchBatchWidgetDataV2 = (widgetIds) => ({
  type: FETCH_BATCH_WIDGET_DATA_V2,
  promise: dashboardV2Service.getBatchWidgetData(widgetIds)
});

// ==================== UI State Actions ====================

export const setDashboardV2Loading = (loading) => ({
  type: SET_DASHBOARD_V2_LOADING,
  payload: loading
});

export const setDashboardV2Error = (error) => ({
  type: SET_DASHBOARD_V2_ERROR,
  payload: error
});
